import { useHistory } from "react-router-dom";

  function Note(props){
     const history = useHistory() 
     const dateFormatting = (data)=>{
        let date = new Date(data) 
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let month = date.getMonth()
        let day = date.getDate()
        let year = date.getFullYear()
        let dateString = day + ' - '+ months[month] + ' - ' + year;
        return dateString 
     }
    //  const contentFomatting = (data) =>{
    //      if(data.length>50){
    //          let cont = data.substring(0,50) + ' .....';
    //          return cont
    //      }
    //      return data
    //  }
     const deleteNotePropMethod = (id) =>{
        console.info(id)
        props.deleteNote(id)
     }

     const openViewMode = (id,content,createdAt) =>{
        history.push({
          pathname : '/viewnote/'+id,
          state : {content,createdAt}
        })
     }

     const openEditMode = (id,content,createdAt)=>{
       history.push({
         pathname : '/editnote/' + id,
         state : {content,createdAt}
       })
     }
     
     return(
        <div className="card">
        <div className="card-image">
          <figure className="image is-16by9" style={{"max-width":"100%"}}>
            <img src="https://images.pexels.com/photos/5190599/pexels-photo-5190599.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" alt=""/>
          </figure>
        </div>
        <div className="card-content">
          <div className="content has-text-centered is-size-5" style={{"overflow-wrap": "break-word"}}>
            <time dateTime={props.createdAt}>{dateFormatting(props.createdAt)}</time>
          </div>
        </div>
        <footer class="card-footer">
            <button class="button is-danger is-light  card-footer-item" onClick={()=>deleteNotePropMethod(props.id)}>
              <span class="icon is-small">
                <i class="fas fa-trash-alt"></i>
              </span>
              <span>Delete</span>
            </button>
            <button class="button is-light is-success card-footer-item" onClick={()=>openEditMode(props.id,props.content,props.createdAt)}>
              <span class="icon is-small">
                <i class="fas fa-pen-fancy"></i>
              </span>
              <span>Edit</span>
            </button>
            <button class="button is-light is-info card-footer-item" onClick={()=>openViewMode(props.id,props.content,props.createdAt)}>
              <span class="icon is-small">
                <i class="fas fa-eye"></i>
              </span>
              <span>View</span>
            </button>
        </footer>
      </div>
     )
 }

 export default Note